"use client";
import React, { useState } from "react";
import Button from "./../common/Button";

const ReplyForm = ({
  quotedAuthor,
  quotedContent,
  onCancel,
  onSubmit,
  currentUserAvatar = "https://cdn.builder.io/api/v1/image/assets/TEMP/cd934a0d1f7f9fdc556f7854e84fce61bb75c333e1e4a9f093271d0d0d58bc5c?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0",
  currentUserName = "John Doe",
}) => {
  const [replyText, setReplyText] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (replyText.trim()) {
      onSubmit(replyText);
      setReplyText("");
    }
  };

  return (
    <section className="mt-4 p-4 border border-gray-200 rounded-xl bg-gray-50">
      <h3 className="text-lg font-medium text-gray-700 mb-3">Reply to quote</h3>

      {/* Quoted content */}
      <blockquote className="p-3 bg-white border-l-4 border-rose-700 mb-4 rounded">
        <p className="text-sm text-gray-500 mb-1">
          <span className="font-medium text-blue-500">{quotedAuthor}</span>{" "}
          wrote:
        </p>
        <p className="text-sm text-gray-700">{quotedContent}</p>
      </blockquote>

      {/* User info and reply form */}
      <div className="flex gap-3">
        <div className="flex-shrink-0">
          <img
            src={currentUserAvatar}
            alt={currentUserName}
            className="w-10 h-10 rounded-full object-cover"
          />
        </div>

        <form className="flex-1" onSubmit={handleSubmit}>
          <div className="mb-2 text-sm font-medium text-gray-700">
            Replying as <span className="text-blue-500">{currentUserName}</span>
          </div>

          <textarea
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
            placeholder="Write your reply here..."
            className="w-full p-3 border border-gray-300 rounded-lg min-h-[120px] mb-3 focus:outline-none focus:ring-2 focus:ring-rose-700 focus:border-transparent"
            required
          />

          <div className="flex justify-end gap-3">
            <Button
              variant="neutral"
              className="px-4 py-2 border border-gray-700 rounded-[400px] text-sm font-medium"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              className="px-4 py-2 bg-rose-700 text-white rounded-[400px] text-sm font-medium"
            >
              Send Reply
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ReplyForm;
